import React, { useState, useEffect, useCallback } from 'react';
import '../styles/LandingPage.css';
//import marMap from '../assets/image/mrMap.jpeg';
//import engMap from '../assets/image/ensanglimap.png';

import marMap from '../assets/image/hero1.jpg';
import engMap from '../assets/image/hero1.jpg';


import Contact from '../components/LandingPage/Contact';
import { HomeT, currentLanguage } from '../services/LanguageTranslationService';
import Counter from '../components/LandingPage/Counter';
const LandingPage = ({ onLoginClick, onRegisterClick }) => {
  const [activeQuestion, setActiveQuestion] = useState(0);
  const [animatedElements, setAnimatedElements] = useState({
    hero: false,
    faq: false,
    stats: false,
    contact: false
  });

  // Memoized function to check if element is in viewport
  const isInViewport = useCallback((element) => {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    return (
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 0.75 &&
      rect.bottom >= 0
    );
  }, []);

  // Animation on scroll
  useEffect(() => {
    const handleScroll = () => {
      const sections = {
        hero: document.getElementById('home'),
        faq: document.getElementById('faq'),
        stats: document.getElementById('stats'),
        contact: document.getElementById('contact')
      };

      const updatedElements = { ...animatedElements };
      let needsUpdate = false;

      Object.entries(sections).forEach(([key, section]) => {
        const isVisible = isInViewport(section);
        if (isVisible !== updatedElements[key]) {
          updatedElements[key] = isVisible;
          needsUpdate = true;
        }
      });

      if (needsUpdate) {
        setAnimatedElements(updatedElements);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Check on initial load
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, [animatedElements, isInViewport]);

  const toggleQuestion = useCallback((index) => {
    setActiveQuestion(prev => prev === index ? -1 : index);
  }, []);

  // Translated FAQ items
  const faqItems = [
    
   // questions created by departments

  {
    question: HomeT('home.faq20.question'),
    answer: (
      <>
        <p>{HomeT('home.faq20.answer')}</p>
      </>
    )
  },
  {
    question: HomeT('home.faq21.question'),
    answer: (
      <>
        <p>{HomeT('home.faq21.answer')}</p>
      </>
    )
  },
  {
    question: HomeT('home.faq22.question'),
    answer: (
      <>
        <p>{HomeT('home.faq22.answer')}</p>
      </>
    )
  },
  {
    question: HomeT('home.faq23.question'),
    answer: (
      <>
        <ol>
          <li>{HomeT('home.faq23.step1')}</li>
          <li>{HomeT('home.faq23.step2')}</li>
        </ol>
        <p><i>{HomeT('home.faq23.note')}</i></p>
      </>
    )
  },
  {
    question: HomeT('home.faq24.question'),
    answer: (
      <>
        <ol>
          <li>{HomeT('home.faq24.step1')}</li>
          <li>{HomeT('home.faq24.step2')}</li>
          {/*<li>{HomeT('home.faq24.step3')}</li>*/}
        </ol>
      </>
    )
  },
  {
    question: HomeT('home.faq25.question'),
    answer: (
      <>
        <ol>
          <li>{HomeT('home.faq25.step1')}</li>
          <li>{HomeT('home.faq25.step2')}</li>
          <li>{HomeT('home.faq25.step3')}</li>
          <li>{HomeT('home.faq25.step4')}</li>
        </ol>
      </>
    )
  },
  {
    question: HomeT('home.faq26.question'),
    answer: (
      <>
        <p>{HomeT('home.faq26.answer')}</p>
      </>
    )
  },
  {
    question: HomeT('home.faq27.question'),
    answer: (
      <>
        <ol>
          <li>{HomeT('home.faq27.step1')}</li>
         {/*  <li>{HomeT('home.faq27.step2')}</li> */}
        </ol>
        <p><i>{HomeT('home.faq27.note')}</i></p>
      </>
    )
  },
  {
    question: HomeT('home.faq28.question'),
    answer: (
      <>
        <p>{HomeT('home.faq28.answer')}</p>
      </>
    )
  },
  {
    question: HomeT('home.faq29.question'),
    answer: (
      <>
        <ol>
          <li>{HomeT('home.faq29.step1')}</li>
          <li>{HomeT('home.faq29.step2')}</li>
          <li>{HomeT('home.faq29.step3')}</li>
          <li>{HomeT('home.faq29.step4')}</li>
          <li>{HomeT('home.faq29.step5')}</li>
        </ol>
      </>
    )
  },
  {
    question: HomeT('home.faq30.question'),
    answer: (
      <>
        <p>{HomeT('home.faq30.stepsTitle')}</p>
        <ol>
          <li>{HomeT('home.faq30.step1')}</li>
          <li>{HomeT('home.faq30.step2')}</li>
        </ol>
      </>
    )
  }
  
  ];

  return (
    <div className="home">
      <section 
        id="home" 
        className={`certificate-section ${animatedElements.hero ? 'animate-in' : ''}`}
      >
        <div className="map-container slide-in-left">
          <img src={currentLanguage === 'en' ? engMap : marMap} alt="Maharashtra Map" className="mh-map" loading="lazy" />
        </div>
        <div className="certificate-content slide-in-right">
          <div className="content-box">
            <h2>{HomeT('home.getCertificate')}</h2>
            <p className="description">{HomeT('home.description')}</p>
            <div className="certificate-buttons">
              <button 
                className="cert-btn login" 
                onClick={onLoginClick}
                onMouseEnter={(e) => e.currentTarget.classList.add('hover')}
                onMouseLeave={(e) => e.currentTarget.classList.remove('hover')}
              >
                <span className="btn-icon"><i className="fas fa-user"></i></span>
                {HomeT('home.applicantLogin')}
              </button>
              <button 
                className="cert-btn register" 
                onClick={onRegisterClick}
                onMouseEnter={(e) => e.currentTarget.classList.add('hover')}
                onMouseLeave={(e) => e.currentTarget.classList.remove('hover')}
              >
                <span className="btn-icon"><i className="fas fa-user-plus"></i></span>
                {HomeT('home.applicantRegister')}
              </button>
            </div>
          </div>
        </div>
      </section>
      <Counter className={animatedElements.stats ? 'animate-in' : ''} />
      <section 
        id="faq" 
        className={`faq-section ${animatedElements.faq ? 'animate-in' : ''}`}
      >
        <div className="section-container">
          <h2 className="section-title">{HomeT('home.faqTitle')}</h2>
          <div className="section-subtitle">{HomeT('home.faqSubtitle')}</div>
          <div className="faq-container">
            {faqItems.map((item, index) => (
              <div 
                key={index}
                className={`faq-item ${activeQuestion === index ? 'active' : ''}`} 
                onClick={() => toggleQuestion(index)}
              >
                <div className="faq-question">
                  <h3>{item.question}</h3>
                  <span className="toggle-icon">{activeQuestion === index ? '−' : '+'}</span>
                </div>
                {activeQuestion === index && (
                  <div className="faq-content">
                    {item.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="contact" className={`contact-section ${animatedElements.contact ? 'animate-in' : ''}`}>
       <Contact />
      </section>
    </div>
  );
};

export default LandingPage;